import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sort-arrow",
  "use": "sort-arrow-usage",
  "viewBox": "0 0 6 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 6 10\" id=\"sort-arrow\"><path d=\"M2 7h2V0H2z\" /><path d=\"M3 10l2.598-3.75H.402L3 10z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol